import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { useTranslations } from 'hooks/useTranslations';
import Button from 'components/atoms/Button';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';

interface IApplicationProcessIntelligenceReportTableCard {
  data: ITableDataSource;
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
}

const ApplicationProcessIntelligenceReportTableCard = ({
  data,
  handleDelete,
  handleEdit,
}: IApplicationProcessIntelligenceReportTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid size={{ xs: 6 }} sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px', color: colors.gray500 }}>
          {t('licenceConfigurator.intelligenceReport.sourceSystem.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.sourceSystem)}</Typography>
      </Grid>
      <Grid size={{ xs: 6 }} sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px', color: colors.gray500 }}>
          {t('licenceConfigurator.intelligenceReport.instructions.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.instructions)}</Typography>
      </Grid>
      <Grid size={{ xs: 12 }} sx={{ borderTop: `1px solid ${colors.gray200}`, p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '16px', color: colors.gray500 }}>
          {t('general.actions.text')}
        </Typography>
        <Grid container sx={{ gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
          <Button
            id={`licence_configuration-view-${data.id}`}
            label={t('licenceConfigurator.task.delete.column')}
            variant={EButtonVariants.outlined}
            size={EButtonSizes.small}
            onClick={() => handleDelete(data.id as string)}
            fullWidth
            sx={{ width: { xs: '100%', sm: '150px' } }}
          />
          <Button
            id={`licence_configuration-edit-${data.id}`}
            label={t('licenceConfigurator.task.edit.column')}
            variant={EButtonVariants.outlined}
            size={EButtonSizes.small}
            onClick={() => handleEdit(data.id as string)}
            fullWidth
            sx={{ width: { xs: '100%', sm: '150px' } }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ApplicationProcessIntelligenceReportTableCard;
